import React, { useContext } from 'react';

import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';
import { Container, LinkMenu, Header, Links, SocialMediaShare } from './styles';

import { SheetContext } from '../../context/SheetContext';
// import QdtComponent from '../QdtComponent/index.js';

const Navigation: React.FC = () => {
  // const [open, setOpen] = useState(true);
  // const [showSelections, setShowSelections] = useState(false);

  const sheets = useContext(SheetContext);

  // const toggleMenu = useCallback((id: string) => {
  //   // setOpen(!open);
  //   // if (id && id !== 'overview') {
  //   //   setShowSelections(true);
  //   // } else
  //   // setShowSelections(false);
  // }, []);

  const links = sheets.map(sheetLink => (
    <LinkMenu
      key={sheetLink.id}
      to={`/${sheetLink.id}`}
      // onClick={() => toggleMenu(sheetLink.id)}
    >
      <span>
        <sheetLink.menuIcon size={22} />
        {sheetLink.title}
      </span>
    </LinkMenu>
  ));

  // const viz1 = {
  //   type: 'QdtCurrentSelections',
  //   props: { height: '38px' },
  // };

  return (
    <Container>
      <Header>
        {/* <MenuButton onClick={() => toggleMenu('')}>
          Menu
          {!open ? <FiMenu /> : <FiX />}
        </MenuButton> */}
        {/* <Menu open={open}> */}
        <Links>{links}</Links>
        {/* <Menu>

        </Menu> */}
        <SocialMediaShare>
          <span> Share with a friend: </span>
          <div>
            <FacebookShareButton
              url="https://.ipc-global.com/"
              quote="CMS Outpatient Payments - IPC Global"
            >
              <FacebookIcon size={32} round />
            </FacebookShareButton>
            <EmailShareButton
              subject="CMS Outpatient Payments - IPC Global"
              url="https://ipc-global.com/"
              body="Engage with IPC in CMS Outpatient Payments"
            >
              <EmailIcon size={32} round />
            </EmailShareButton>
            <LinkedinShareButton
              title="CMS Outpatient Payments - IPC Global"
              summary="CMS Outpatient Payments - IPC Global"
              source="https://ipc-global.com/"
              url="https://ipc-global.com/"
            >
              <LinkedinIcon size={32} round />
            </LinkedinShareButton>
            <TwitterShareButton
              title="CMS Outpatient Payments - IPC Global"
              url="https://ipc-global.com/"
            >
              <TwitterIcon size={32} round />
            </TwitterShareButton>
          </div>
        </SocialMediaShare>
      </Header>
      {/* {showSelections && (
        <SelectionsBar>
          <QdtComponent type={viz1.type} props={viz1.props} />
        </SelectionsBar>
      )} */}
    </Container>
  );
};

export default Navigation;
